(function () {
  'use strict';

  function escapeHtml(str) {
    if (str == null) return '';
    var div = document.createElement('div');
    div.textContent = String(str);
    return div.innerHTML;
  }

  function getDistance(lat1, lon1, lat2, lon2) {
    var R = 3959; // miles
    var dLat = (lat2 - lat1) * Math.PI / 180;
    var dLon = (lon2 - lon1) * Math.PI / 180;
    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
            Math.sin(dLon / 2) * Math.sin(dLon / 2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
  }

  function init() {
    var mapEl = document.getElementById('merchant-map');
    if (!mapEl || typeof L === 'undefined') return;

    var map = L.map('merchant-map', {
      scrollWheelZoom: false,
      gestureHandling: false
    }).setView([54.5, -2.5], 6);

    mapEl.addEventListener('click', function () {
      map.scrollWheelZoom.enable();
      mapEl.classList.add('map-active');
    });
    document.addEventListener('click', function (e) {
      if (!mapEl.contains(e.target)) {
        map.scrollWheelZoom.disable();
        mapEl.classList.remove('map-active');
      }
    });
    map.touchZoom.enable();
    map.dragging.enable();

    L.tileLayer('https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png', {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
      subdomains: 'abcd',
      maxZoom: 19,
      updateWhenIdle: true,
      keepBuffer: 2
    }).addTo(map);

    var customIcon = L.divIcon({
      className: 'custom-leaflet-marker',
      html:
        '<div class="glowing-marker-wrapper">' +
          '<div class="glowing-marker-halo"></div>' +
          '<div class="glowing-marker">' +
            '<div class="glowing-marker-inner">' +
              '<span class="glowing-marker-label">BALLISTOL</span>' +
            '</div>' +
          '</div>' +
        '</div>',
      iconSize: [30, 40],
      iconAnchor: [15, 38],
      popupAnchor: [0, -35]
    });

    var allStores = [];
    var bounds = L.latLngBounds();
    var listContainer = document.getElementById('merchant-directory-list');
    var stockistCount = document.getElementById('stockistCount');

    function buildCard(store, searchLat, searchLng) {
      var card = document.createElement('div');
      card.className = 'directory-card';

      var distanceText = '';
      if (searchLat != null && searchLng != null) {
        var dist = getDistance(searchLat, searchLng, store.position.lat, store.position.lng);
        distanceText = '<span class="store-distance">' + dist.toFixed(1) + ' miles away</span>';
      }

      var logoHtml;
      if (store.logo) {
        logoHtml =
          '<img src="' + escapeHtml(store.logo) + '"' +
          ' alt="' + escapeHtml(store.title) + '"' +
          ' class="store-logo-img"' +
          ' loading="lazy"' +
          ' decoding="async"' +
          ' width="56" height="56"' +
          ' referrerpolicy="no-referrer"' +
          ' onerror="this.style.display=\'none\'">';
      } else {
        logoHtml =
          '<div class="store-placeholder-svg">' +
            '<svg width="32" height="32" viewBox="0 0 24 24" fill="#ff0000" aria-hidden="true">' +
              '<path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>' +
            '</svg>' +
          '</div>';
      }

      card.innerHTML =
        '<div class="store-col store-col-image">' + logoHtml + '</div>' +
        '<div class="store-col store-col-info">' +
          '<div class="store-info-text">' +
            '<h4>' + escapeHtml(store.title) + '</h4>' +
            '<p class="store-category">' + escapeHtml(store.category || '') + '</p>' +
            '<p class="store-address">' + escapeHtml(store.address || '') + '</p>' +
            (store.phone ? '<p class="store-phone">📞 ' + escapeHtml(store.phone) + '</p>' : '') +
            distanceText +
          '</div>' +
          '<div class="store-info-footer">' +
            '<a href="' + escapeHtml(store.website || '#') + '"' +
            ' target="_blank" rel="noopener noreferrer"' +
            ' class="directions-btn">View Distributor →</a>' +
          '</div>' +
        '</div>';

      card.addEventListener('click', function (e) {
        if (e.target.tagName.toLowerCase() === 'a') return;
        map.flyTo([store.position.lat, store.position.lng], 14, { duration: 1 });
        if (store._marker) store._marker.openPopup();
      });

      return card;
    }

    function renderStores(stores, searchLat, searchLng) {
      while (listContainer.firstChild) listContainer.removeChild(listContainer.firstChild);
      if (stockistCount) stockistCount.textContent = stores.length + ' FOUND';

      var frag = document.createDocumentFragment();
      for (var i = 0; i < stores.length; i++) {
        frag.appendChild(buildCard(stores[i], searchLat, searchLng));
      }
      listContainer.appendChild(frag);
    }

    // Seed markers + list
    if (window.merchantStoresData && window.merchantStoresData.length > 0) {
      window.merchantStoresData.forEach(function (store) {
        var marker = L.marker([store.position.lat, store.position.lng], { icon: customIcon }).addTo(map);
        marker.bindPopup(
          "<div style='text-align:center;'>" +
            "<b>" + escapeHtml(store.title) + "</b><br>" +
            "<span style='font-size:11px;color:#666;'>" + escapeHtml(store.category || '') + "</span><br>" +
            "<span style='font-size:10px;'>" + escapeHtml(store.address || '') + "</span>" +
          "</div>"
        );
        store._marker = marker;
        bounds.extend([store.position.lat, store.position.lng]);
        allStores.push(store);
      });

      if (allStores.length > 0) map.fitBounds(bounds.pad(0.1));
      renderStores(allStores);
    }

    // Stop halo pulse after the initial attention window (saves GPU on idle)
    setTimeout(function () { mapEl.classList.add('halo-settled'); }, 4000);

    // Search
    var searchInput = document.getElementById('stockistSearchInput');
    var searchBtn = document.getElementById('stockistSearchBtn');
    var searchDebounce;
    var currentAbort;

    function textFilter(query) {
      var q = query.toLowerCase();
      return allStores.filter(function (s) {
        return (s.title || '').toLowerCase().indexOf(q) !== -1 ||
               (s.address && s.address.toLowerCase().indexOf(q) !== -1);
      });
    }

    function doSearch() {
      if (!searchInput) return;
      var query = searchInput.value.trim();
      if (!query) {
        renderStores(allStores);
        if (allStores.length > 0) map.fitBounds(bounds.pad(0.1));
        return;
      }

      if (currentAbort) currentAbort.abort();
      currentAbort = (typeof AbortController !== 'undefined') ? new AbortController() : null;

      var url = 'https://nominatim.openstreetmap.org/search?format=json&q=' +
                encodeURIComponent(query + ', UK') + '&limit=1';

      var fetchOpts = currentAbort ? { signal: currentAbort.signal } : undefined;

      fetch(url, fetchOpts)
        .then(function (res) { return res.json(); })
        .then(function (data) {
          if (data && data.length > 0) {
            var lat = parseFloat(data[0].lat);
            var lng = parseFloat(data[0].lon);
            var sorted = allStores.slice().map(function (s) {
              s._distance = getDistance(lat, lng, s.position.lat, s.position.lng);
              return s;
            }).sort(function (a, b) { return a._distance - b._distance; });
            renderStores(sorted, lat, lng);
            map.setView([lat, lng], 10);
          } else {
            renderStores(textFilter(query));
          }
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          renderStores(textFilter(query));
        });
    }

    if (searchBtn) searchBtn.addEventListener('click', doSearch);
    if (searchInput) {
      searchInput.addEventListener('input', function () {
        clearTimeout(searchDebounce);
        searchDebounce = setTimeout(doSearch, 350);
      });
      searchInput.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          clearTimeout(searchDebounce);
          doSearch();
        }
      });
    }
  }

  // Deferred script: DOM is parsed. Leaflet is loaded earlier in the defer queue.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
